import Image from "next/image";
import Link from "next/link";
import AboutData from "../../data/elements/about.json";
import { useParallax } from "react-scroll-parallax";

const About = () => {
  const { ref: ref1, style: style1 } = useParallax({ translateY: [0, -15] });
  const { ref: ref2, style: style2 } = useParallax({ translateY: [0, 15] });

  const data = AboutData.aboutOne[0];

  return (
    <div className="container">
      <div className="row g-5">

        {/* ── Image collage ── */}
        <div className="col-lg-6">
          <div className="about-media-sticky">
            <div style={{ position: "relative", minHeight: "520px" }}>

              {/* Main large image */}
              <div
                ref={ref1}
                style={{
                  ...style1,
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "68%",
                  borderRadius: "16px",
                  overflow: "hidden",
                  boxShadow: "0 16px 48px rgba(0,0,0,0.18)",
                  zIndex: 2,
                }}
              >
                <img
                  src="https://img.freepik.com/free-photo/young-bearded-student-guy-red-polo-shirt-with-backpack-holding-airline-tickets-globe-looking-surprised-standing_141793-98693.jpg?w=996"
                  alt="Immigration student"
                  style={{ width: "100%", height: "380px", objectFit: "cover", display: "block" }}
                />
              </div>

              {/* Second image — right side */}
              <div
                ref={ref2}
                style={{
                  ...style2,
                  position: "absolute",
                  top: "120px",
                  right: 0,
                  width: "52%",
                  borderRadius: "16px",
                  overflow: "hidden",
                  boxShadow: "0 16px 48px rgba(0,0,0,0.18)",
                  zIndex: 3,
                }}
              >
                <img
                  src="https://img.freepik.com/free-photo/visa-application-composition-with-american-flag_23-2149117752.jpg?w=1380"
                  alt="Visa application"
                  style={{ width: "100%", height: "260px", objectFit: "cover", display: "block" }}
                />
              </div>

              {/* Experience badge */}
              <div
                style={{
                  position: "absolute",
                  bottom: "10px",
                  left: "20px",
                  background: "#DB6827",
                  color: "#fff",
                  borderRadius: "14px",
                  padding: "18px 24px",
                  boxShadow: "0 8px 24px rgba(219,104,39,0.4)",
                  zIndex: 4,
                  textAlign: "center",
                }}
              >
                <span style={{ fontSize: "36px", fontWeight: "800", lineHeight: 1, display: "block" }}>
                  12+
                </span>
                <span style={{ fontSize: "13px", fontWeight: "600", opacity: 0.9 }}>
                  Years of Excellence
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* ── Text content ── */}
        <div className="col-lg-6">
          <div className="inner pl_lg--50 pl_sm--0 pl_md--0">

            <div className="section-title text-start mb-4">
              <span
                className="subtitle bg-coral-opacity"
                style={{ color: "#DB6827", fontWeight: "700", fontSize: "13px", letterSpacing: "1.5px", textTransform: "uppercase" }}
              >
                {data.tag}
              </span>
              <h2 className="title mt-2">
                {data.title} <br />
                <span style={{ color: "#DB6827" }}>{data.subTitle}</span>
              </h2>
            </div>

            <p style={{ color: "#64748b", fontSize: "15.5px", lineHeight: "1.8", marginBottom: "32px" }}>
              {data.desc}
            </p>

            {/* Feature items */}
            <div style={{ display: "flex", flexDirection: "column", gap: "20px", marginBottom: "36px" }}>
              {data.children.map((item, i) => (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "16px",
                    padding: "18px 20px",
                    background: "#f8fafc",
                    borderRadius: "12px",
                    border: "1px solid #f1f5f9",
                    transition: "box-shadow 0.2s",
                  }}
                >
                  <div
                    style={{
                      width: "44px",
                      height: "44px",
                      borderRadius: "10px",
                      background: item.isPrimary ? "#fff7f0" : "#fdf2f8",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <i
                      className={item.icon}
                      style={{ fontSize: "18px", color: item.isPrimary ? "#DB6827" : "#ec4899" }}
                    />
                  </div>
                  <div>
                    <h6 style={{ fontWeight: "700", color: "#0f172a", marginBottom: "4px", fontSize: "15px" }}>
                      {item.title}
                    </h6>
                    <p style={{ color: "#64748b", fontSize: "13.5px", lineHeight: "1.6", marginBottom: 0 }}>
                      {item.info}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <button
              className="rbt-btn btn-gradient radius-round"
              style={{ border: "none", cursor: "pointer" }}
              onClick={() =>
                document
                  .getElementById("contact-form")
                  ?.scrollIntoView({ behavior: "smooth" })
              }
            >
              Start Your Journey &rarr;
            </button>
          </div>
        </div>
      </div>

      <style jsx>{`
        @media (min-width: 992px) {
          .about-media-sticky {
            position: sticky;
            top: 110px;
          }
        }
      `}</style>
    </div>
  );
};

export default About;
